import script from "./aviso.vue?vue&type=script&setup=true&lang=js"
export * from "./aviso.vue?vue&type=script&setup=true&lang=js"

import "./aviso.vue?vue&type=style&index=0&id=af189f5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af189f5e"]])

export default __exports__